module.exports = "/_next/static/images/empty-box-f10cadad.png";